import { render, staticRenderFns } from "./ShippingFeeList.vue?vue&type=template&id=8956f0ee&scoped=true&"
import script from "./ShippingFeeList.vue?vue&type=script&lang=js&"
export * from "./ShippingFeeList.vue?vue&type=script&lang=js&"
import style0 from "./ShippingFeeList.vue?vue&type=style&index=0&id=8956f0ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8956f0ee",
  null
  
)

export default component.exports